import { createSvgIcon } from '@mui/material';

const IconSameDay = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g id="Group_10684" data-name="Group 10684" transform="translate(-679 -1924)">
      <g id="Group_10186" data-name="Group 10186" transform="translate(-16 -42)">
        <rect
          id="Rectangle_5271"
          data-name="Rectangle 5271"
          width="50"
          height="50"
          rx="25"
          transform="translate(695 1966)"
          fill="#f7f8f8"
        />
      </g>
      <g id="Group_6411" data-name="Group 6411" transform="translate(687.563 1939.816)">
        <circle
          id="Ellipse_631"
          data-name="Ellipse 631"
          cx="2.36"
          cy="2.36"
          r="2.36"
          transform="translate(2.684 13.946)"
          fill="none"
          stroke="#85C440"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <circle
          id="Ellipse_632"
          data-name="Ellipse 632"
          cx="2.36"
          cy="2.36"
          r="2.36"
          transform="translate(15.499 13.946)"
          fill="none"
          stroke="#85C440"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_3422"
          data-name="Path 3422"
          d="M4.135,21.2H16.2V37.284m-10.724,0H2.795m8.042,0h6.924m6.48,0h0A2.68,2.68,0,0,0,26.922,34.6V29.241H16.2m0-6.7h2.724a7.024,7.024,0,0,1,6.024,3.412l1.973,3.29"
          transform="translate(-2.795 -21.199)"
          fill="none"
          stroke="#85C440"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          id="Line_904"
          data-name="Line 904"
          x1="5.951"
          transform="translate(2.214 7.031)"
          fill="none"
          stroke="#85C440"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <g id="logo-99minutos.6ca31ef5" transform="translate(683.564 1928.362)">
        <g id="Group_10683" data-name="Group 10683">
          <path
            id="Fill-14"
            d="M153.995,94.414l3.129-3.129s-2.018-5.147-9.284-9.386l-3.129,3.129,3.633,3.633-.808.808A18.969,18.969,0,0,0,116.251,104a18.973,18.973,0,1,0,33.4-12.413l.807-.807Zm-3.936,9.284a14.886,14.886,0,1,1-14.835-15.037A14.988,14.988,0,0,1,150.059,103.7Z"
            transform="translate(-116.251 -81.9)"
            fill="#85C440"
            stroke="#85C440"
            strokeWidth="1"
          />
        </g>
      </g>
    </g>
  </svg>,

  'IconSameDay',
);

export default IconSameDay;
